module.exports = __webpack_public_path__ + "static/media/display-area.e4630387.png";